import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/components/ThemeProvider";
import { Github } from "lucide-react";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";
import SignUp from "@/pages/SignUp";
import Login from "@/pages/Login";
import AdminUsers from "@/pages/AdminUsers";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import FeedbackDashboard from "@/pages/FeedbackDashboard";
import CreateConference from "@/pages/CreateConference";
import EditConference from "@/pages/EditConference";
import CreateWorkshop from "@/pages/CreateWorkshop";
import CreateTrip from "@/pages/CreateTrip";
import CreateTripForm from "@/pages/CreateTripForm";
import EditTrip from "@/pages/EditTrip";
import CreateBazaar from "@/pages/CreateBazaar";
import VendorDashboard from "@/pages/VendorDashboard";
import SportsFacilities from "@/pages/SportsFacilities";
import MyEvents from "@/pages/MyEvents";
import WorkshopApprovals from "@/pages/WorkshopApprovals";
import VendorRequests from "@/pages/VendorRequests";
import ProfessorDashboard from "@/pages/ProfessorDashboard";
import WorkshopManagement from "@/pages/WorkshopManagement";
import EditWorkshop from "@/pages/EditWorkshop";
import EventsOfficeDashboard from "@/pages/EventsOfficeDashboard";
import StaffTADashboard from "@/pages/StaffTADashboard";
import NotFound from "@/pages/not-found";
import EmailVerified from "@/pages/EmailVerified";
import AttendeeDetails from "@/pages/AttendeeDetails";
import ProtectedRoute from "@/components/ProtectedRoute";
import EventListPage from "@/pages/EventListPage";
import StaffUpcomingEvents from "@/pages/StaffUpcomingEvents";
import ArchivedEvents from "@/pages/ArchivedEvents";
import SalesReport from "@/components/SalesReportPage";
import FavoritesPage from "@/pages/FavoritesPage";

import EventsOfficeReportPage from "@/pages/EventsReportPage";
import BoothVotePage from "@/pages/BoothVotePage";
import EventsOfficePolls from "@/pages/EventsOfficePolls";
import ApprovedLoyaltyPartnersPage from "@/pages/ApprovedLoyaltyPartnersPage";
import CalendarPage from "@/pages/CalendarPage";
import LiveMoments from "@/pages/LiveMoments";
function Router() {
  return (
    <Switch>
      <Route path="/" component={Login} />
      <Route path="/signup" component={SignUp} />
      <Route path="/login" component={Login} />
      <Route path="/verify-email/:token" component={EmailVerified} />
      <Route path="/attendee/:token" component={AttendeeDetails} />
      <Route path="/dashboard" component={Dashboard} />

      <Route path="/home">
        <ProtectedRoute allowedRoles={["student"]}>
          <Home />
        </ProtectedRoute>
      </Route>

      <Route path="/booth-vote">
        <ProtectedRoute allowedRoles={["student", "staff", "ta", "professor"]}>
          <BoothVotePage />
        </ProtectedRoute>
      </Route>

      <Route path="/live-moments">
        <ProtectedRoute
          allowedRoles={[
            "student",
            "staff",
            "ta",
            "professor",
            "events_office",
            "admin",
          ]}
        >
          <LiveMoments />
        </ProtectedRoute>
      </Route>

      <Route path="/admin">
        <ProtectedRoute allowedRoles={["admin"]}>
          <AdminDashboardPage />
        </ProtectedRoute>
      </Route>
      <Route path="/feedback">
        <ProtectedRoute
          allowedRoles={[
            "admin",
            "events_office",
            "student",
            "staff",
            "ta",
            "professor",
          ]}
        >
          <FeedbackDashboard />
        </ProtectedRoute>
      </Route>
      <Route path="/events-office/create/conference">
        <ProtectedRoute allowedRoles={["events_office"]}>
          <CreateConference />
        </ProtectedRoute>
      </Route>
      <Route path="/events-office/events/conference/edit/:id">
        <ProtectedRoute allowedRoles={["events_office"]}>
          <EditConference />
        </ProtectedRoute>
      </Route>
      <Route path="/admin/users">
        <ProtectedRoute allowedRoles={["admin"]}>
          <AdminUsers />
        </ProtectedRoute>
      </Route>
      <Route path="/professor">
        <ProtectedRoute allowedRoles={["professor"]}>
          <ProfessorDashboard />
        </ProtectedRoute>
      </Route>
      <Route path="/professor/workshops">
        <ProtectedRoute allowedRoles={["professor"]}>
          <WorkshopManagement />
        </ProtectedRoute>
      </Route>
      <Route path="/professor/create-workshop">
        <ProtectedRoute allowedRoles={["professor"]}>
          <CreateWorkshop />
        </ProtectedRoute>
      </Route>
      <Route path="/professor/edit-workshop/:id">
        <ProtectedRoute allowedRoles={["professor"]}>
          <EditWorkshop />
        </ProtectedRoute>
      </Route>
      <Route path="/trips">
        <ProtectedRoute allowedRoles={["events_office"]}>
          <CreateTrip />
        </ProtectedRoute>
      </Route>
      <Route path="/events-office/create/trip">
        <ProtectedRoute allowedRoles={["events_office"]}>
          <CreateTripForm />
        </ProtectedRoute>
      </Route>
      <Route path="/events-office/events/trip/edit/:id">
        <ProtectedRoute allowedRoles={["events_office"]}>
          <EditTrip />
        </ProtectedRoute>
      </Route>
      <Route path="/staff-ta">
        <ProtectedRoute allowedRoles={["staff", "ta"]}>
          <StaffTADashboard />
        </ProtectedRoute>
      </Route>
      <Route path="/staff-ta/upcoming">
        <ProtectedRoute allowedRoles={["staff", "ta"]}>
          <StaffUpcomingEvents />
        </ProtectedRoute>
      </Route>

      <Route path="/create/bazaar">
        <ProtectedRoute allowedRoles={["events_office"]}>
          <CreateBazaar />
        </ProtectedRoute>
      </Route>
      <Route path="/vendor/dashboard">
        <ProtectedRoute allowedRoles={["vendor"]}>
          <VendorDashboard />
        </ProtectedRoute>
      </Route>
      <Route path="/events-office/dashboard">
        <ProtectedRoute allowedRoles={["events_office"]}>
          <EventsOfficeDashboard />
        </ProtectedRoute>
      </Route>

      <Route path="/events-office/polls">
        <ProtectedRoute allowedRoles={["events_office", "admin"]}>
          <EventsOfficePolls />
        </ProtectedRoute>
      </Route>

      <Route path="/events-office/archived">
        <ProtectedRoute allowedRoles={["events_office"]}>
          <ArchivedEvents />
        </ProtectedRoute>
      </Route>

      <Route path="/sports">
        <ProtectedRoute
          allowedRoles={[
            "student",
            "staff",
            "events_office",
            "ta",
            "professor",
          ]}
        >
          <SportsFacilities />
        </ProtectedRoute>
      </Route>

      <Route path="/approvals/workshops">
        <ProtectedRoute allowedRoles={["events_office"]}>
          <WorkshopApprovals />
        </ProtectedRoute>
      </Route>

      <Route path="/my-events">
        <ProtectedRoute
          allowedRoles={[
            "student",
            "staff",
            "events_office",
            "ta",
            "professor",
          ]}
        >
          <MyEvents />
        </ProtectedRoute>
      </Route>

      <Route path="/vendor-requests">
        <ProtectedRoute allowedRoles={["admin", "events_office"]}>
          <VendorRequests />
        </ProtectedRoute>
      </Route>
      <Route path="/events">
        <ProtectedRoute allowedRoles={["admin", "events_office"]}>
          <EventListPage />
        </ProtectedRoute>
      </Route>

      <Route path="/favorites">
        <ProtectedRoute allowedRoles={["student", "staff", "ta", "professor"]}>
          <FavoritesPage />
        </ProtectedRoute>
      </Route>
      <Route path="/reports/attendees">
        <ProtectedRoute allowedRoles={["events_office", "admin"]}>
          <EventsOfficeReportPage />
        </ProtectedRoute>
      </Route>
      <Route path="/loyalty-partners">
        <ProtectedRoute
          allowedRoles={[
            "student",
            "staff",
            "ta",
            "professor",
            "events_office",
            "admin",
          ]}
        >
          <ApprovedLoyaltyPartnersPage />
        </ProtectedRoute>
      </Route>
      <Route path="/reports/sales">
        <ProtectedRoute allowedRoles={["events_office", "admin"]}>
          <SalesReport />
        </ProtectedRoute>
      </Route>

      <Route path="/calendar">
        <ProtectedRoute
          allowedRoles={["student", "staff", "ta", "professor", "vendor"]}
        >
          <CalendarPage />
        </ProtectedRoute>
      </Route>

      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  const isDisrupted =
    import.meta.env.VITE_DB_DISRUPTED === "true" ||
    import.meta.env.VITE_DB_DISRUPTED === "1";

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          {isDisrupted && (
            <div className="bg-red-600 text-white p-4 text-center z-[100] relative">
              <p className="font-semibold text-sm md:text-base">
                Database is disrupted due to ongoing issue in UAE/Bahrain and
                we're working on a migration.
              </p>
              <p className="text-sm mt-1 flex items-center justify-center gap-2">
                For the meantime view the repository:
                <a
                  href="https://github.com/Advanced-Computer-Lab-2025/Eventy"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 underline hover:text-red-200 font-medium"
                >
                  <Github className="w-4 h-4" />
                  GitHub Repository
                </a>
              </p>
              <div className="mt-2 space-x-4 text-sm">
                <a
                  href="https://status.mongodb.com/incidents/7g5qmxgkc2y4"
                  target="_blank"
                  rel="noreferrer"
                  className="underline hover:text-red-200"
                >
                  MongoDB Status
                </a>
                <a
                  href="https://health.aws.amazon.com/health/status"
                  target="_blank"
                  rel="noreferrer"
                  className="underline hover:text-red-200"
                >
                  AWS Status
                </a>
              </div>
            </div>
          )}
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
